function pmInit(root){
  if(!root||root.dataset.pmReady)return;root.dataset.pmReady='1';

  var tips={
    fold:'<b>Fold.</b> ¿Cuánto equity tiene A5s contra un rango de 3-bet de BB? ¿Y qué pierdes al no defender nunca esta mano?',
    call:'<b>Call.</b> Jugarás fuera de posición con un bote grande. ¿Qué SPR queda y cómo vas a realizar tu equity?',
    '4bet':'<b>4-bet.</b> El As bloquea AA y AK. ¿Con qué manos de valor equilibras esta línea?'
  };
  var fb=root.querySelector('[data-pm-feedback]');
  root.querySelectorAll('.pm-act').forEach(function(b){
    b.addEventListener('click',function(){
      root.querySelectorAll('.pm-act').forEach(function(x){x.classList.remove('is-on')});
      b.classList.add('is-on');
      fb.innerHTML=tips[b.getAttribute('data-k')]+' <span style="color:#F5C542">Estas preguntas se responden en el curso.</span>';
    });
  });
  root.querySelectorAll('.pm-tab').forEach(function(t){
    t.addEventListener('click',function(){
      root.querySelectorAll('.pm-tab').forEach(function(x){x.classList.remove('is-on')});
      t.classList.add('is-on');
    });
  });

  function lines(t){return (t||'').split(/\r?\n/).map(function(x){return x.trim()}).filter(Boolean)}
  function fillList(ul,t){ul.innerHTML='';lines(t).forEach(function(x){var li=document.createElement('li');li.textContent=x;ul.appendChild(li)})}
  root.querySelectorAll('[data-pm-lines]').forEach(function(ul){fillList(ul,ul.getAttribute('data-pm-lines'))});
  root.querySelectorAll('[data-pm-stars]').forEach(function(el){var n=parseInt(el.getAttribute('data-pm-stars'),10)||5;el.textContent='★★★★★'.slice(0,n)+'☆☆☆☆☆'.slice(0,5-n)});

  var modal=root.querySelector('[data-pm-modal]');
  if(modal){

    var q=function(k){return modal.querySelector('[data-m="'+k+'"]')},last=null;
    function close(){modal.hidden=true;document.documentElement.style.overflow='';if(last)last.focus()}
    root.querySelectorAll('[data-pm-course]').forEach(function(c){
      c.addEventListener('click',function(e){
        e.preventDefault();last=c;var d=c.dataset;
        q('n').textContent=d.n;q('l').textContent=d.l;q('t').textContent=d.t;q('r').textContent=d.r;
        q('p').textContent=d.p;q('pa').textContent=d.pa||'';q('o').textContent=d.o||'';
        fillList(q('temas'),d.temas);
        q('link').setAttribute('href',c.getAttribute('href'));
        var soon=d.soon==='1',buy=q('buy'),nt=q('notify'),sb=q('sub');if(sb)sb.hidden=false;
        if(buy)buy.hidden=soon;if(nt)nt.hidden=!soon;
        var tg=q('tags');if(tg)tg.value='aviso-curso, aviso-curso-'+d.n;
        modal.hidden=false;document.documentElement.style.overflow='hidden';
        modal.querySelector('.pm-modal-x').focus();
      });
    });
    if(modal.querySelector('[data-pm-ok]')&&location.hash.indexOf('pm-aviso-form')>-1){
      var sb=q('sub');if(sb)sb.hidden=true;q('n').textContent='✓';q('l').textContent='Aviso activado';q('t').textContent='Te avisaremos';q('r').textContent='';q('temas').innerHTML='';
      var b2=q('buy');if(b2)b2.hidden=true;q('notify').hidden=false;modal.hidden=false;
    }
    modal.querySelectorAll('[data-pm-close]').forEach(function(x){x.addEventListener('click',close)});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!modal.hidden)close()});
  }

  var rv=root.querySelector('[data-pm-reviews]');
  if(rv){
    var prev=root.querySelector('[data-pm-prev]'),next=root.querySelector('[data-pm-next]'),bar=root.querySelector('[data-pm-bar]'),cnt=root.querySelector('[data-pm-count]');
    var items=rv.querySelectorAll('.pm-review');
    var step=function(){var c=items[0];return c?c.getBoundingClientRect().width+16:rv.clientWidth};
    var upd=function(){
      var max=rv.scrollWidth-rv.clientWidth,per=Math.max(1,Math.round(rv.clientWidth/step())),first=Math.round(rv.scrollLeft/step())+1;
      var last=Math.min(items.length,first+per-1);
      if(cnt)cnt.textContent=items.length?first+'–'+last+' de '+items.length:'';
      if(bar){bar.style.width=(items.length?Math.min(100,per/items.length*100):100)+'%';bar.style.transform='translateX('+(max>0?rv.scrollLeft/max*(100/(Math.min(100,per/items.length*100)/100)-100):0)+'%)'}
      if(prev)prev.disabled=rv.scrollLeft<=2;if(next)next.disabled=rv.scrollLeft>=max-2;
    };
    prev&&prev.addEventListener('click',function(){rv.scrollBy({left:-step()*Math.max(1,Math.round(rv.clientWidth/step())),behavior:'smooth'})});
    next&&next.addEventListener('click',function(){rv.scrollBy({left:step()*Math.max(1,Math.round(rv.clientWidth/step())),behavior:'smooth'})});
    rv.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',upd);upd();
    var down=false,sx=0,sl=0,moved=false;
    rv.addEventListener('mousedown',function(e){down=true;moved=false;sx=e.pageX;sl=rv.scrollLeft;rv.classList.add('is-drag')});
    window.addEventListener('mousemove',function(e){if(!down)return;var dx=e.pageX-sx;if(Math.abs(dx)>3)moved=true;rv.scrollLeft=sl-dx});
    window.addEventListener('mouseup',function(){if(!down)return;down=false;rv.classList.remove('is-drag');var s=step();rv.scrollTo({left:Math.round(rv.scrollLeft/s)*s,behavior:'smooth'})});
  }

  var R='AKQJT98765432'.split(''),grid=root.querySelector('[data-pm-grid]');
  var hEl=root.querySelector('[data-pm-hand]'),cEl=root.querySelector('[data-pm-combos]'),tEl=root.querySelector('[data-pm-type]');
  /* Distribución ilustrativa con fines didácticos (no es un rango de solver) */
  function cls(i,j){
    var hi=Math.min(i,j),lo=Math.max(i,j);
    if(i===j) return hi<=4?'c-a':'c-c';
    if(i<j){
      if(hi===0) return lo<=3?'c-a':lo>=8?'c-b':'c-c';
      if(lo-hi===1&&lo<=9) return 'c-c';
      if(hi<=3&&lo<=4) return 'c-b';
      if(hi<=2) return 'c-c';
      return '';
    }
    if(hi===0&&lo<=2) return lo===1?'c-a':'c-b';
    if(hi<=2&&lo<=3) return 'c-c';
    return '';
  }
  for(var i=0;i<13;i++){for(var j=0;j<13;j++){
    var n=i===j?R[i]+R[j]:i<j?R[i]+R[j]+'s':R[j]+R[i]+'o';
    var d=document.createElement('div');
    d.className='pm-cell '+cls(i,j);d.textContent=n;d.setAttribute('data-h',n);
    if(n==='A5s')d.classList.add('is-sel');
    grid.appendChild(d);
  }}
  grid.addEventListener('click',function(e){
    var c=e.target.closest('.pm-cell');if(!c)return;
    grid.querySelectorAll('.is-sel').forEach(function(x){x.classList.remove('is-sel')});
    c.classList.add('is-sel');
    var h=c.getAttribute('data-h');
    hEl.textContent=h;
    if(h.length===2){cEl.textContent='6';tEl.textContent='Pareja'}
    else if(h[2]==='s'){cEl.textContent='4';tEl.textContent='Suited'}
    else{cEl.textContent='12';tEl.textContent='Offsuit'}
  });
}
document.querySelectorAll('.pm:not(.pm-x)').forEach(pmInit);
document.addEventListener('shopify:section:load',function(e){e.target.querySelectorAll('.pm:not(.pm-x)').forEach(pmInit)});
